import React from 'react';
import {ShowIf} from 'components/utils';
import { connect } from 'react-redux';
import { Radio, RadioGroup } from '@blueprintjs/core';
import {Link} from 'react-router';
import {AutoCompleteSearch} from "modules/auto-complete";
import { Reception, DuLieuHeThong } from 'api';
import {msg} from "constants/message";
import {DropDownChonTinhThanh, DropDownChonDanToc, DropDownChonQuanHuyen, DropDownChonQuocTich, DropDownChonPhuongXa} from 'components/tt-forms';
import { DatePicker, DropDownMultipleSelect } from 'components/tt-forms/common';
import {Input} from 'components/tt-forms/common';
import { ConfirmDialog } from 'modules/dialog';
import { Toastr } from 'modules/toastr';
import { get } from "lodash";

import {validatable} from 'components/utils';
var Promise = require('es6-promise').Promise;

class ThongTinCaNhan extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: this.props.data,
      typingTimeout: 0,
      autoCompleteData: [],
      autoCompletePage: '',
      confirmIndex: '',
      confirmData: {},
      isOpenConfirm: false,
      checked: false,
      noiCapList: [],
      ofs: false
    }
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'DISPLAY_FORM',
      value: !get(this.props, 'isDonCu')
    });
    if(this.props.noiCapCMND.length == 0) {
      DuLieuHeThong.actions.getNoiCap.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'noiCapCMND',
            data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
          }]
        })
      })
    }
    if (this.props.noiCapCMND.length) {
      this.props.noiCapCMND.map((item) => {
        this.state.noiCapList.push({value: item.coQuanQuanLyId, label: item.ten});
      });
    }
    this.setState({...this.state});
    if (!localStorage.getItem('tpdnId')) {
      this.props.dispatch({
        type: 'GET_TPID',
        value: true
      });
    }
  }

  onChange(name, e) {
    let value = e.target ? e.target.value : e;

    let newData = {
      ...this.state.data,
      [name]: value
    }

    if (name == 'tinhThanhId' || name == 'quanHuyenId' || name == 'phuongXaId') {
      newData.toThon = '';
      if (name == 'tinhThanhId' || name == 'quanHuyenId') {
        newData.phuongXaId = '';
        if (name == 'tinhThanhId') {
          newData.diaChi = '';
          newData.quanHuyenId = '';
          newData.tinhThanhCongDan.ten = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
        } else {
          newData.quanHuyenCongDan.ten = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
        }
      } else {
        newData.phuongXaCongDan.ten = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
      }
    }

    this.setState({
      data: newData
    });

    this.props.onChange(newData);

    if ((name == 'soCMNDHoChieu' || name == 'diaChi') && !this.props.uyQuyen) {
      this.checkCongDanExist(newData);
    }
  }

  checkCongDanExist(data) {
    if (data.hoVaTen && data.soCMNDHoChieu && data.diaChi) {
      let params = {
        tuKhoa: data.hoVaTen.trim(),
        soCMND: data.soCMNDHoChieu.trim(),
        diaChi: data.diaChi.trim()
      }
      Reception.actions.getCongDanExist.request(null, params).then(res => {
        if (res.data) {
          this.setState({
            isOpenConfirm: true,
            confirmIndex: this.props.index,
            confirmData: res.data
          });
        }
      });
    } else if (data.soCMNDHoChieu && !this.state.checked) {
      Reception.actions.getCMNDExist.request(null, {
        soCMND: data.soCMNDHoChieu
      }).then(res => {
        if (res.data) {
          this.state.checked = true;
          Toastr(msg.dataExist, 'warning');
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.noiCapCMND != nextProps.noiCapCMND && nextProps.noiCapCMND.length) {
      this.state.noiCapList = [];
      nextProps.noiCapCMND.map((item) => {
        this.state.noiCapList.push({value: item.coQuanQuanLyId, label: item.ten});
      });
    }
    this.state.data = nextProps.data;
    this.setState({...this.state});
  }

  searchCongDan(hoVaTen) {
    let inputParams = {
      size: 3,
      page: 0
    }

    inputParams.tuKhoa = hoVaTen;

    return Reception.actions.searchCongDan.request('', inputParams).then(res => {
      if (res.data && res.data._embedded) {
        return Promise.resolve({
          result: res.data._embedded.congDans,
          page: res.data.page
        });
      } else {
        return Promise.resolve(null);
      }
    }).catch(err => {
      return Promise.reject(err);
    });
  }
  handleChangeDate(name, e) {
    let newData = {
      ...this.state.data
    }
    if (e && e._d) {
      newData[name] = e._d;
    } else {
      newData[name] = e;
    }
    this.setState({
      data: newData
    });

    this.props.onChange(newData);
  }

  replaceThongTinCaNhan() {
    this.props.dispatch({
      type: 'CHON_CONG_DAN',
      data: this.state.confirmData,
      index: this.state.confirmIndex
    });
    this.closeDialogConfirm();
  }

  closeDialogConfirm() {
    let state = this.state;
    state.isOpenConfirm = false;
    this.setState(state);
    this.props.dispatch({
      type: 'DISPLAY_FIELD',
      value: true
    });
  }

  render() {
    let dnId = localStorage.getItem('tpdnId') || '';
    let idDonCD = null;
    let checkUQ = false;
    if (this.props && this.props.data && this.props.data.donCongDanId) {
      idDonCD = this.props.data.donCongDanId;
    }
    if (this.props && this.props.uyQuyen === true) {
      checkUQ = true;
    }
    let getHoTen = '';
    if (this.props && this.props.data && this.props.data.hoVaTen) {
      getHoTen = this.props.data.hoVaTen;
    }
    return (
      <div>
        <ConfirmDialog open={this.state.isOpenConfirm} onClose={this.closeDialogConfirm.bind(this)} onSuccess={this.replaceThongTinCaNhan.bind(this)}/>
        <ShowIf condition={(this.props.label != "")}>
          <div className="title">
            <div className="rows">
              <div className="col-12">
                <h4>{this.props.label}
                  <ShowIf condition={this.props.isRemoveable}>
                    <Link className="link-remove itt-delete" onClick={this.props.handleRemove}>
                      Xóa
                    </Link>
                  </ShowIf>
                </h4>
              </div>
            </div>
          </div>
        </ShowIf>
        <div className="items-form">
          <div className="rows">
            <ShowIf condition={(checkUQ === false)}>
              <AutoCompleteSearch
                label="Họ và tên"
                isRequired={true}
                onSearch={this.searchCongDan}
                onChange={this.onChange.bind(this, 'hoVaTen')}
                value={this.state.data.hoVaTen}
                maxLength={50}
                index={this.props.index}
                bindValidator={this}
                channel="formTaoDon"
                name="hoVaTen"
                disabled={getHoTen && this.props.nguoiDaiDien && this.props.nguoiDaiDien.length > 0 && this.props.nguoiDaiDien[this.props.index] && this.props.nguoiDaiDien[this.props.index].congDanId && !this.props.isDonCu ? true : this.props.showForm}
                idDonCD = {idDonCD}
                showField = {getHoTen}
                />
            </ShowIf>
            <ShowIf condition={(checkUQ === true)}>
              <Input label="Họ và tên" className="col-input" name="hoVaTen" maxLength={40} value={this.state.data.hoVaTen} onChange={this.onChange.bind(this, 'hoVaTen')} bindValidator={this}
                channel="formTaoDon" require/>
              <DatePicker label='Ngày sinh' name="ngaySinh" endDate={new Date()} value={this.state.data.ngaySinh} onChange={ this.handleChangeDate.bind(this, 'ngaySinh') } />
            </ShowIf>
            <ShowIf condition={(checkUQ === false)}>
              <DatePicker label='Ngày sinh' name="ngaySinh" endDate={new Date()} value={this.state.data.ngaySinh} onChange={ this.handleChangeDate.bind(this, 'ngaySinh') } disabled={this.props.showForm} />
              <Input label="Số điện thoại" disabled={getHoTen && !this.props.isDonCu  ? false : this.props.showForm} className="col-input" name="soDienThoai" type="sdt" maxLength={15} value={this.state.data.soDienThoai} onChange={this.onChange.bind(this, 'soDienThoai')}/>
              <div className="col-4">
              <RadioGroup
                label="Giới tính"
                name={this.props.index}
                className="radio-gender val-title-radio-group"
                onChange={this.onChange.bind(this, 'gioiTinh')}
                selectedValue={this.state.data.gioiTinh}
                disabled={ getHoTen && !this.props.isDonCu ? false : this.props.showForm }
              >
                <Radio label="Nam" value="male" className="pt-large" disabled={getHoTen && !this.props.isDonCu ? false : this.props.showForm}/>
                <Radio label="Nữ" value="female" className="pt-large" disabled={getHoTen && !this.props.isDonCu ? false : this.props.showForm}/>
              </RadioGroup>
            </div>
            </ShowIf>
            <ShowIf condition={(checkUQ === true)}>
            <div className="col-4">
              <RadioGroup
                label="Giới tính"
                name={this.props.index}
                className="radio-gender val-title-radio-group"
                onChange={this.onChange.bind(this, 'gioiTinh')}
                selectedValue={this.state.data.gioiTinh}
              >
                <Radio label="Nam" value="male" className="pt-large"/>
                <Radio label="Nữ" value="female" className="pt-large"/>
              </RadioGroup>
            </div>
            </ShowIf>
          </div>
        </div>
        <div className="items-form">
          <div className="rows">
          <ShowIf condition={(checkUQ === true)}>
            <Input label="Số CMND/Hộ chiếu/CCCD" name="soCMND" className="col-input" type="cmnd" maxLength={15} value={this.state.data.soCMNDHoChieu} onChange={this.onChange.bind(this, 'soCMNDHoChieu')}/>
            <DatePicker label='Ngày cấp' name="ngayCap" endDate={new Date()} value={this.state.data.ngayCap} onChange={ this.handleChangeDate.bind(this, 'ngayCap') } />
            <DropDownMultipleSelect multi={false} name="DropDownChonNoiCapCMND" className="col-input" label="Nơi cấp" options={this.state.noiCapList} placeholder={{key: '', text: '--Chọn--'}} value={this.state.data.noiCap} onChange={this.onChange.bind(this, 'noiCap')}/>
            <DropDownChonQuocTich selectedValue={this.state.data.quocTichId} onChange={this.onChange.bind(this, 'quocTichId')}/>
            <DropDownChonDanToc selectedValue={this.state.data.danTocId} onChange={this.onChange.bind(this, 'danTocId')} quocTichID={this.state.data.quocTichId}/>
          </ShowIf>
          <ShowIf condition={(checkUQ === false)}>
            <Input label="Số CMND/Hộ chiếu/CCCD" name="soCMND" className="col-input" type="cmnd" maxLength={15} value={this.state.data.soCMNDHoChieu} onChange={this.onChange.bind(this, 'soCMNDHoChieu')} disabled={getHoTen && !this.props.isDonCu ? false : this.props.showForm}/>
            <DatePicker label='Ngày cấp' name="ngayCap" endDate={new Date()} value={this.state.data.ngayCap} onChange={ this.handleChangeDate.bind(this, 'ngayCap') } disabled={getHoTen && !this.props.isDonCu ? false : this.props.showForm}/>
            <DropDownMultipleSelect multi={false} name="DropDownChonNoiCapCMND" className="col-input" label="Nơi cấp" options={this.state.noiCapList} placeholder={{key: '', text: '--Chọn--'}} value={this.state.data.noiCap} onChange={this.onChange.bind(this, 'noiCap')} disabled={getHoTen && !this.props.isDonCu ? false : this.props.showForm}/>
            <DropDownChonQuocTich selectedValue={this.state.data.quocTichId} onChange={this.onChange.bind(this, 'quocTichId')} disabled={getHoTen && !this.props.isDonCu ? false : this.props.showForm}/>
            <DropDownChonDanToc selectedValue={this.state.data.danTocId} onChange={this.onChange.bind(this, 'danTocId')} quocTichID={this.state.data.quocTichId} disabled={getHoTen && !this.props.isDonCu ? false : this.props.showForm}/>
          </ShowIf>
          </div>
        </div>
        <div className="items-form">
          <div className="rows">
            <ShowIf condition={(checkUQ === false)}>
              <DropDownChonTinhThanh placeholder={null} selectedValue={this.state.data.tinhThanhId} onChange={this.onChange.bind(this, 'tinhThanhId')} disabled={getHoTen && !this.props.isDonCu ? false : this.props.showForm}/>
              {
                (parseInt(this.state.data.tinhThanhId) === parseInt(dnId)) &&
                  <DropDownChonQuanHuyen selectedValue={this.state.data.quanHuyenId} thanhPhoID={this.state.data.tinhThanhId}  onChange={this.onChange.bind(this, 'quanHuyenId')} disabled={getHoTen && !this.props.isDonCu ? false : this.props.showForm}/>
              }
              {
                (parseInt(this.state.data.tinhThanhId) === parseInt(dnId)) &&
                  <DropDownChonPhuongXa selectedValue={this.state.data.phuongXaId} quanHuyenId={this.state.data.quanHuyenId} thanhPhoID={this.state.data.tinhThanhId} onChange={this.onChange.bind(this, 'phuongXaId')} disabled={getHoTen && !this.props.isDonCu ? false : this.props.showForm}/>
              }
              <Input label="Địa chỉ(Số nhà/Tên đường/Tổ, thôn)" className={'col-w40'} name="diaChi" type="text" maxLength={999} value={this.state.data.diaChi} onChange={this.onChange.bind(this, 'diaChi')} bindValidator={this}
                  channel="formTaoDon" require disabled={getHoTen && !this.props.isDonCu ? false : this.props.showForm}/>
            </ShowIf>
            <ShowIf condition={(checkUQ === true)}>
              <DropDownChonTinhThanh placeholder={null} selectedValue={this.state.data.tinhThanhId} onChange={this.onChange.bind(this, 'tinhThanhId')}/>
              {
                (parseInt(this.state.data.tinhThanhId) === parseInt(dnId)) &&
                  <DropDownChonQuanHuyen selectedValue={this.state.data.quanHuyenId} thanhPhoID={this.state.data.tinhThanhId}  onChange={this.onChange.bind(this, 'quanHuyenId')}/>
              }
              {
                (parseInt(this.state.data.tinhThanhId) === parseInt(dnId)) &&
                  <DropDownChonPhuongXa selectedValue={this.state.data.phuongXaId} quanHuyenId={this.state.data.quanHuyenId} thanhPhoID={this.state.data.tinhThanhId} onChange={this.onChange.bind(this, 'phuongXaId')}/>
              }
              <Input label="Địa chỉ(Số nhà/Tên đường/Tổ, thôn)" className={'col-w40'} name="diaChi" type="text" maxLength={999} value={this.state.data.diaChi} onChange={this.onChange.bind(this, 'diaChi')} bindValidator={this}
                  channel="formTaoDon" require/>
            </ShowIf>
            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    )
  }
}

ThongTinCaNhan.defaultProps = {
  handleRemove: function() {
    console.log('Need to assign onChange method');
  },
  uyQuyen: false,
  noiCapCMND: []
}

function bindStateToProps(state) {
  return {
    noiCapCMND: state.duLieuHeThong.noiCapCMND,
    showForm: state.duLieuHeThong.showForm,
    showField: state.formDataTiepCongDan.showField,
    nguoiDaiDien: state.formDataTiepCongDan.nguoiDungDon
  }
}

export default connect(bindStateToProps)(validatable(ThongTinCaNhan));



// WEBPACK FOOTER //
// ./src/components/modules/reception/ThongTinCaNhan.jsx